<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        {{ userStore.user.address }}<br/>
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br>
        {{ userStore.user.ssn }} <br>
        <br>
        {{ creditBureau.address_name }} <br>
        {{ creditBureau.street_address }} <br>
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }} 
        <br>
        <br>
        Date: {{ date }}
    </p>
    <div class="page">
        <p>
            <strong>ATTN:</strong> {{ creditBureau.name }},
        </p>
        <p>
            I received the letter with your dispute results and I need to know WHY these
            accounts are still remaining or you are claiming they have been verified.
            That’s impossible because these creditors are denying any record of a
            dispute from your company! These accounts are still reporting errors:
            <br><br>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <strong>NAME OF ACCOUNT:</strong> {{ creditor.furnisher_name }}
                <br />
                <template v-if="creditor.reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                    <br />
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                    <br />
                </template>
                <strong>METHOD OF VERIFICATION REASON:</strong>
                This account is continuing to report errors after you claimed to have <strong>verified</strong> it. I have reason to believe that you failed to conduct a <strong>re-investigation</strong> of my disputes. Therefore the following account(s) could not have been <strong>verified</strong>.
                <br />
                <br />
            </template>
        </p>
        <p class="letter-content">
            How can this be?! Please explain to me how your agency has “so-called”
            verified these accounts? I’m allowed to ask and you’re REQUIRED to answer.
            <br>
            So how did you do it?! <br> Who did you talk to in the creditor’s
            office?<br> Did you send them the information about the account that I sent in?<br>
            How did you send it to them? <br>
            Did you fax it, did you mail it, did you use the same mailing
            address and/or telephone number listed on the credit report that I have …<br>
            What did you do? And furthermore, what steps did this agency take to ensure
            that the creditor actually investigated my dispute rather than just
            fraudulently telling you that it’s been verified?
        </p>
        <p class="letter-content">
            The FCRA says that you
            have to tell me this within <strong>15 days</strong> if I ask. And please do not send me any
            more of your generic response letters of how you use various methods.
            I’m asking for <strong>“SPECIFICS”</strong> on exactly how your agency actually verified these
            accounts that you are erroneously reporting about me and I need the full
            name of the person you spoke with or who told you electronically that it was
            verified.
        </p>
        <p class="letter-content">
            If you do not know then you need to find out and shame on you if
            you do not know because that would NOT be a proper investigation on your
            part as you are required to conduct.
        </p>
        <p class="letter-content">
            Any automated response or e-Oscar verification is unacceptable. I am
            requesting a <strong>RE-Investigation</strong> AND your <strong>Method of Verification</strong>.
        </p>
        <p class="letter-content">
            Be aware that I am making a final goodwill attempt to have you clear up this
            matter. The listed item is entirely inaccurate and incomplete, and
            represents a very serious error in your reporting.
            <br> <br>
            I am maintaining a careful record of my communications with you for the
            purpose of filing a complaint with the Consumer Financial Protection Bureau
            and the Attorney General’s office, should you continue in your
            noncompliance. I further remind you that, as in <strong>Wenger v. Trans Union Corp.,
            No. 95-6445 (C.D.Cal. Nov. 14, 1995)</strong>, you may be liable for your willful
            non-compliance.
            <br><br>
            Failure to respond satisfactorily within 30 days of receipt of this
            certified letter may result in a small claims action against your company,
            seeking $1,000 per violation for:
            1.) Defamation
            2.) Negligent Enablement of Identity Fraud
            3.) Violations of the Fair Credit Reporting Act
        </p>
        <p>
            My contact information is stated above.
            <br>
            <br>
            P.S. Please be aware that dependent upon your response, I may be detailing
            any potential issues with your company via an online public press release,
            including documentation of any potential small claims action.
            <br>
            <br>
            Cc: Consumer Financial Protection Bureau <br>
            Cc: Attorney General’s Office <br>
            Cc: Better Business Bureau <br>
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            {{ userStore.user.address }}<br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br>
            {{ userStore.user.ssn }}
        </p>
    </div>
    <h1 style="margin: 5rem 5rem;">Personal Information</h1>
    <div class="row">
        <p>
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>